import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CustomStep from './CustomStep';
import withSizes from 'react-sizes';

const styles = theme => ({
    
});

class CustomStepper extends Component {

    state = {
        windowHeight: undefined,
        windowWidth: undefined,
        stepsName: ['Chatbot', 'Verification', 'Choose Arbitrator', 'Read PDF', 'Signature', 'Payment', 'Upload Documents'],
        lang: localStorage.getItem('language')
    };

    componentDidMount(){
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    }

    componentWillMount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        })
    } 

    render(){
        const { classes, activeStep } = this.props;
        // console.log('activeSteP:  '+this.props.activeStep + ' '+(this.props.activeStep == 3) + ' '+(!(this.state.windowWidth <= 500 || this.props.isMobile)))
        if (!(this.state.windowWidth <= 500 || this.props.isMobile)){
            if (this.props.activeStep == 0){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>

                            <CustomStep icon="1" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')} ></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 1){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 2){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        

                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 3){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            

                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 4){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        

                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 5){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            

                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 6){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '':'50px'}}>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                            <CustomStep icon="empty"></CustomStep>
                        </div>
                    </div>
                )
            }
        }
        else{
            if (this.props.activeStep == 0){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '150px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '150px':'50px'}}>
                            <CustomStep icon="1" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 1){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px'}}>
                            <CustomStep icon="1" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[0])}></CustomStep>
                            <CustomStep icon="2" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 2){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px'}}>
                           
                            <CustomStep icon="2" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[1])}></CustomStep>
                            <CustomStep icon="3" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 3){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px'}}>

                            <CustomStep icon="3" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[2])} title2={this.context.t(this.state.stepsName[2]+'2')}></CustomStep>
                            <CustomStep icon="4" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 4){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px'}}>

                            <CustomStep icon="4"lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[3])}></CustomStep>
                            <CustomStep icon="5" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 5){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '50px':'50px'}}>

                            <CustomStep icon="5" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[4])}></CustomStep>
                            <CustomStep icon="6" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                        </div>
                    </div>
                )
            }
            else if (this.props.activeStep == 6){
                return(
                    <div style={{marginTop:'20px',  marginBottom:'20px'}}>
                        <div style={{ background:'#B71C1C', position: 'absolute', top:'16px', width:'100vw', height:'3px', zIndex:1  }}></div>
                        <div style={{justifyContent:"space-between",  display: 'flex', backgroundColor:'white', marginLeft: this.state.windowWidth <= 500 || this.props.isMobile ? '150px':'50px', marginRight:this.state.windowWidth <= 500 || this.props.isMobile ? '150px':'50px'}}>
                            <CustomStep icon="6" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[5])}></CustomStep>
                            <CustomStep icon="7" size="big" lang={this.props.caseData.language} title={this.context.t(this.state.stepsName[6])} title2={this.context.t(this.state.stepsName[6]+'2')}></CustomStep>
                        </div>
                    </div>
                )
            }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimantArbitratorName: state.caseInfo.claimantArbitratorName,
        respondentArbitratorName: state.caseInfo.respondentArbitratorName,
        lang: state.i18nState.lang,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
   
    }
}

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),
  })

CustomStepper.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps) (withStyles(styles)(withRouter(CustomStepper))));
